export default class tracking {
	constructor({
		address,
		battery,
		city,
		company_id,
		created_at,
		cx,
		cy,
		date,
		decoded_data,
		gps,
		imei,
		original_data,
		resource_id,
		send_mail_battery,
		send_mail_calendar,
		send_mail_detention,
		send_mail_zone,
		version,
		active,
		positionrecord_id,
		version_os,
		username,
		max_speed,
		speed,
	}) {
		this.username = username ? username : "";
		this.address = address || "";
		this.battery = battery || 0;
		this.city = city || "";
		this.company_id = company_id || "";
		this.created_at = created_at || "";
		this.cx = cx || "";
		this.cy = cy || "";
		this.date = date || "";
		this.decoded_data = decoded_data || "";
		this.gps = gps || "";
		this.imei = imei || "";
		this.original_data = original_data || "";
		this.resource_id = resource_id || "";
		this.send_mail_battery = send_mail_battery || "";
		this.send_mail_calendar = send_mail_calendar || "";
		this.send_mail_detention = send_mail_detention || "";
		this.send_mail_zone = send_mail_zone || "";
		this.version = version || "";
		this.version_os = version_os ? version_os : "";
		this.active = active !== undefined && active ? true : false;
		this.howLong = 0; // ninutes
		this.positionrecord_id = positionrecord_id || null; // ninutes
		this.max_speed = max_speed ? Number(max_speed) : 0;
		this.speed = speed ? Number(speed) : 0;

		this.calculateHowLongLastTransmision();
	}

	getBatteryIcon() {
		if (this.battery >= 60) {
			return {icon: "BatteryIcon", color: "text-success"};
		} else if (this.battery < 60 && this.battery >= 30) {
			return {icon: "BatteryIcon", color: "text-warning"};
		} else {
			return {icon: "BatteryChargingIcon", color: "text-danger"};
		}
	}

	calculateHowLongLastTransmision() {
		const currenDate = new Date();
		const lastTransmisionDate = new Date(this.date);
		this.howLong = Math.floor((currenDate.getTime() - lastTransmisionDate.getTime()) / (1000 * 60));
	}

	getTransmissionColor() {
		if (this.active) return "text-success";
		else return "text-danger";
	}

	getTransmissionText() {
		if (this.active) return "OnLine";
		else return "OffLine";
	}

	get maxSpeed() {
		return this.max_speed;
	}

	set maxSpeed(maxSpeed) {
		this.max_speed = maxSpeed;
	}
}
